<template>
  <v-app id="app">
    <v-content>
      <myHeader />

      <v-container fill-height>
        <v-layout>
          <v-flex>
            <v-alert
              class="mb-3 py-2 mt-4"
              transition="scale-transition"
              dismissible
              v-model="alert"
              :color="this.$store.getters['master/alert'].type"
              :type="this.$store.getters['master/alert'].type"
              outlined
              >{{ this.$store.getters["master/alert"].message }}</v-alert
            >

            <router-view />
          </v-flex>
        </v-layout>
      </v-container>

      <myFooter />
    </v-content>
  </v-app>
</template>

<script>
import myHeader from "../partials/HeaderEmbed.vue"
import myFooter from "../partials/FooterEmbed.vue"

export default {
  name: "embed-layout",

  components: {
    myHeader,
    myFooter
  },

  computed: {
    alert: {
      get() {
        return this.$store.getters["master/alert"].show
      },
      set() {
        this.$globalMessages("", "", false)
        return false
      }
    }
  }
}
</script>
